import {configureStore} from '@reduxjs/toolkit';
import {promiseResolverMiddleware} from '~/common/middleware/promiseResolver';
import {rootReducer} from './reducers';

const store = configureStore({
  reducer: rootReducer,
});
type RootState = ReturnType<typeof store.getState>;

export function createGalleryStore(initialState: RootState) {
  return configureStore({
    reducer: rootReducer,
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false,
      }).concat(promiseResolverMiddleware),
  });
}
